/* QILATES — lightweight motion: scroll reveal, staggered groups, count-up, sticky zone narrative.
   One file, native IntersectionObserver, fully degraded under prefers-reduced-motion. */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    // ---- Scroll reveal (single + groups) ----
    var reveals = document.querySelectorAll('[data-reveal], [data-reveal-group]');
    if (reduce) {
      reveals.forEach(function (el) { el.classList.add('is-in'); });
    } else {
      document.querySelectorAll('[data-reveal-group]').forEach(function (g) {
        Array.prototype.forEach.call(g.children, function (c, i) { c.style.setProperty('--i', i); });
      });
      var io = new IntersectionObserver(function (entries, obs) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('is-in'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.14, rootMargin: '0px 0px -8% 0px' });
      reveals.forEach(function (el) { io.observe(el); });
    }

    // ---- Count-up numbers ----
    var nums = document.querySelectorAll('.q-count[data-count-to]');
    if (nums.length) {
      var runCount = function (el) {
        var to = parseFloat(el.dataset.countTo);
        var suffix = el.dataset.suffix || '';
        var prefix = el.dataset.prefix || '';
        if (reduce) { el.textContent = prefix + to.toLocaleString() + suffix; return; }
        var dur = 1500, t0 = performance.now();
        var step = function (now) {
          var p = Math.min((now - t0) / dur, 1);
          var eased = 1 - Math.pow(1 - p, 3);
          el.textContent = prefix + Math.round(to * eased).toLocaleString() + suffix;
          if (p < 1) requestAnimationFrame(step);
        };
        requestAnimationFrame(step);
      };
      var ioN = new IntersectionObserver(function (es, obs) {
        es.forEach(function (e) { if (e.isIntersecting) { runCount(e.target); obs.unobserve(e.target); } });
      }, { threshold: 0.6 });
      nums.forEach(function (n) { ioN.observe(n); });
    }

    // ---- Sticky zone narrative: right-hand steps swap the pinned image ----
    document.querySelectorAll('[data-sticky-narrative]').forEach(function (wrap) {
      var layers = wrap.querySelectorAll('[data-layer]');
      var steps = wrap.querySelectorAll('[data-step]');
      if (!layers.length || !steps.length) return;
      var setActive = function (i) {
        layers.forEach(function (l) { l.classList.toggle('is-active', String(l.dataset.layer) === String(i)); });
        steps.forEach(function (s) { s.classList.toggle('is-active', String(s.dataset.step) === String(i)); });
      };
      setActive(0);
      if (reduce) { steps.forEach(function (s) { s.classList.add('is-active'); }); layers.forEach(function (l) { l.classList.add('is-active'); }); return; }
      var ioS = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) setActive(e.target.dataset.step); });
      }, { threshold: 0.55 });
      steps.forEach(function (s) { ioS.observe(s); });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
